// Intersection Observer for Scrollspy functionality
document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('.restaurant-category-container');
    const navLinks = document.querySelectorAll('.restaurant-category-link');
    const navContainer = document.querySelector('.restaurant-categories');

    if (sections.length === 0 || navLinks.length === 0) return;

    const observerOptions = {
        root: null,
        rootMargin: '-30% 0px -69% 0px', // Trigger when section is near top
        threshold: 0
    };

    const observerCallback = (entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const id = entry.target.id;

                // Remove active class from all
                navLinks.forEach(link => link.classList.remove('active'));

                // Add active class to current
                const activeLink = document.querySelector(`.restaurant-category-link[href="#${id}"]`);
                if (activeLink) {
                    activeLink.classList.add('active');

                    // Scroll horizontal nav to keep active link in view
                    const linkLeft = activeLink.offsetLeft;
                    const linkWidth = activeLink.offsetWidth;
                    const containerWidth = navContainer.offsetWidth;

                    navContainer.scrollTo({
                        left: linkLeft - (containerWidth / 2) + (linkWidth / 2),
                        behavior: 'smooth'
                    });
                }
            }
        });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    sections.forEach(section => {
        observer.observe(section);
    });

    // Smooth scroll for anchor clicks
    navLinks.forEach(link => {
        link.addEventListener('click', function (e) {
            e.preventDefault();
            const targetId = this.getAttribute('href');
            const targetSection = document.querySelector(targetId);

            if (targetSection) {
                window.scrollTo({
                    top: targetSection.offsetTop - 120, // offset for sticky headers
                    behavior: 'smooth'
                });
            }
        });
    });
});
